import PaginationModule from './PaginationModule'
import RouterModule from './RouterModule'
import MenuModule from './MenuModule'

Vue.component(PaginationModule.name, PaginationModule)
Vue.component(RouterModule.name, RouterModule)
Vue.component(MenuModule.name, MenuModule)



// WEBPACK FOOTER //
// ./src/js/components/Modules/index.js